<ng-container *ngIf="!loading">
  <router-outlet></router-outlet>
</ng-container>